import { memo } from 'react';
import useHomePage from '../queries/useHomePage';
import StoryblokRender from '../../content/components/StoryblokRender';
import { FluidProgressIndicator } from '../../core/components/ProgressIndicators';
import Container from '../../core/components/Container';
import withErrorBoundary from '../../core/components/errors/withErrorBoundary';
import { VStack } from '../../library';
import { PageTitle } from '../../core/components/PageTitle';
import { MetaContent } from '../../core/MetaContent';
import styles from './HomePage.module.scss';

const HomePage = memo(() => {
    const { data, loading } = useHomePage();

    return (
        <>
            {data?.meta_fields?.title && (
                <PageTitle title={data.meta_fields.title} />
            )}
            {data?.meta_fields?.description && (
                <MetaContent
                    content={data.meta_fields.description}
                    name="description"
                />
            )}
            <div className={styles.container} data-test-class="homePage">
                <Container>
                    <VStack gap="large">
                        {loading || !data ? (
                            <div className={styles.progressIndicatorContainer}>
                                <FluidProgressIndicator />
                            </div>
                        ) : (
                            <StoryblokRender
                                components={data.body}
                                scrollToElement
                            />
                        )}
                    </VStack>
                </Container>
            </div>
        </>
    );
});

export default memo(
    withErrorBoundary(HomePage, {
        errorComponent: ({ defaultErrorMessage }) => (
            <div className={styles.container} data-test-class="homePage">
                <Container>{defaultErrorMessage}</Container>
            </div>
        ),
    })
);
